<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>周报数据查询</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
            <el-row>
                <el-col :span="6">
                        <el-select v-model="formInline.city" placeholder="选择银行" clearable>
                            <el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
                                :key="key">
                            </el-option>
                        </el-select>
                </el-col>
                <el-col :span="6">
                    <el-date-picker v-model="formInline.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-date-picker v-model="formInline.endDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    <el-button size="small" type="warning" @click="exportData">生成周报</el-button>
                    <el-button size="small" type="warning" @click="exportDataTrading">导出交易表</el-button>
                    <el-button size="small" type="warning" @click="exportDataBuyBack">导出回购表</el-button>
                </el-col>
            </el-row>
		</el-form>

		<div class="title">期间概述</div>
		<div class="content">本周期，正回购{{weekData.zhgCount}}笔，逆回购{{weekData.nhgCount}}笔，本周期持仓利息收入{{ towNumber(weekData.chicanglixi/10000,2) }}万元
            (期末{{weekData.chicanglixiEndDate}}-期初{{weekData.chicanglixiStartDate}}：{{weekData.chicanglixiEnd}} - {{weekData.chicanglixiStart}})，
回购利息收入{{towNumber((weekData.nhgShouRu+weekData.zhgZhiChu)/10000,2)}}万元；现券交易{{weekData.xianjuanjiaoyibishu}}笔。截至{{weekData.analysisDate}}，正回购{{weekData.zhgSum/10000}}
亿元，逆回购{{weekData.nhgSum/10000}}亿元，债券持仓{{weekData.zhaiquanchicangzonge/10000}}亿元，资金运营总收入{{towNumber(weekData.zijinyunyingzongshouru/10000,2)}}万元，
年化收益率{{towNumber(weekData.benzhoushouyilv,2)}}%。</div>


<div class="content">期末时，交易总收入{{weekData.qmjyzsr}}元，回购总收入{{towNumber(weekData.hgzsr,2)}}元，前台费用{{ towNumber(weekData.qtfy,2) }}元，后台费用{{ towNumber(weekData.htfy,2) }}元，
总头寸{{weekData.bondPositionAll/100000000}}亿元，天数{{weekData.tianshu}}天，收益率{{towNumber(weekData.qmsyl,2)}}%。</div>


		<div class="title">回购交易</div>
		<el-table size="small" :data="weekData.hgt" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
			<el-table-column prop="direction" label="方向" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.direction=='positive'">正回购</div>
						<div v-else-if="scope.row.direction=='reverse'">逆回购</div>
						<div v-else>-</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="tradingDate" label="交易日期" align="center"></el-table-column>
			<el-table-column prop="dueDate" label="到期日期" align="center"></el-table-column>
			<el-table-column prop="v" label="金额【万】" align="center"></el-table-column>
			<el-table-column prop="rate" label="利率【%】" align="center"></el-table-column>
			<!-- <el-table-column prop="period" label="期限【天】" align="center"></el-table-column>
			<el-table-column prop="income" label="收入" align="center"></el-table-column> -->
		</el-table>
		<el-card shadow="never">
				<el-row>
					<el-col :span="4">
						<div>正回购金额[万]：{{weekData.zhgSum}}</div>
					</el-col>
					<el-col :span="4">
						<div>正回购支出：{{towNumber(weekData.zhgZhiChu,2)}}</div>
					</el-col>
					<el-col :span="4">
						<div>逆回购金额[万]：{{weekData.nhgSum}}</div>
					</el-col>
					<el-col :span="4">
						<div>逆回购收入：{{towNumber(weekData.nhgShouRu,2)}}</div>
					</el-col>
					<el-col :span="4">
						<div>回购收入：{{towNumber(weekData.nhgShouRu+weekData.zhgZhiChu,2)}}</div>
					</el-col>
				</el-row>
			</el-card>


		<div class="title">债券持仓</div>
		<el-table size="small" :data="weekData.bcc" title='wwwww' highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
			<el-table-column sortable prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
            <el-table-column prop="jq" label="久期" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="结算日期" align="center"></el-table-column>
			<el-table-column prop="buyVolume" label="数量【万】" align="center"></el-table-column>
			<el-table-column prop="buyValue" label="买入收益率【%】" align="center"></el-table-column>
			<el-table-column prop="sellValue" label="估值收益率【%】" align="center"></el-table-column>
			<el-table-column prop="totalIncome" label="净收入【元】" align="center">
                <template slot-scope="scope"> 
					<div>{{scope.row.totalIncome}}</div>
                    <!--+scope.row.interestPayed-->
					<!-- <div>{{scope.row.buyDate}}</div>
					<div>{{scope.row.buyNetPrice}}</div>
                    <div>{{scope.row.buyFullPrice}}</div>
					<div>{{scope.row.buyValue}}</div> -->
                </template>
            </el-table-column>
            <!-- <el-table-column prop="interestPayed" label="票息兑付【元】" align="center"></el-table-column> -->
		</el-table>

		<div>
			<el-card shadow="never">
				<el-row>
					<el-col :span="4">
						<div>持仓总额【万】：{{weekData.zhaiquanchicangzonge}}</div>
					</el-col>
					<el-col :span="4">
						<div>净收入【元】：{{weekData.zhaiquanchicangjingshouru}}</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<div class="title">期间债券交易</div>
		<el-table size="small" :data="weekData.bondTrading" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
			<el-table-column sortable prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
			<el-table-column prop="city" label="银行" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="买入" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.buyDate}}</div>
					<div>{{scope.row.buyNetPrice}}</div>
                    <div>{{scope.row.buyFullPrice}}</div>
					<div>{{scope.row.buyValue}}</div>
                </template>
			</el-table-column>
			<el-table-column prop="buyVolume" label="买入量" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="卖出" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.sellDate}}</div>
					<div>{{scope.row.sellNetPrice}}</div>
                    <div>{{scope.row.sellFullPrice}}</div>
					<div>{{scope.row.sellValue}}</div>
                </template>
			</el-table-column>

			<el-table-column prop="totalIncome" label="价差" align="center"></el-table-column>
			<el-table-column prop="capitalGains" label="资本利得" align="center"></el-table-column>
			<el-table-column prop="interestIncome" label="利息收入" align="center"></el-table-column>
			<el-table-column prop="interestPayed" label="票息兑付" align="center"></el-table-column>
		</el-table>
		

	</div>
</template>


<script>
	// import { Divider } from 'element-ui';
import {
		getAllCity,
        getManageCity,
		generateWord,
		getWeekReport,

        getBuyBackListExport,
        getBondHoldAnalysisListExport
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
    // mixins: [methodsMixin],
    // 模块数据
    data() {
        //数据  
        return {
            cityList: [],
            manageCityList:[],
            analysisMap: {},
            listData: [],

			weekData:{},



            businessType: "normal",
            alldata: false,
            checkAll: false,
            isIndeterminate: true,
            checkedLimit: [],


            loading: false,
            Visible: false,
            time: [],
            checkboxGroup: [],
            type: "showVip",
            fileList: [],
            dialogImageUrl: "",
            dialogVisible: false,

            // 所属分类
            tableData: [],
            value: [],
            editForm: {},
            selectEditForm: {},
            usernames: ""
        };
    },
    watch: {},
    methods: {
        towNumber(val, len) {
            return parseFloat(val).toFixed(len);
        },
        changeRowBgColor({ row }) {
            let styleJson = {};
            if (row.isHold === 1) {
                styleJson = { "color": "red" };
            }
            return styleJson;
        },
        exportData() {
            let param = this.formInline;
            generateWord(param);
        },
        exportDataBuyBack() {
            this.formInline.isValid='yes'
				let param = this.formInline
				getBuyBackListExport(param)
			},
            exportDataTrading() {
                this.formInline.analysisDate=this.formInline.endDate
				let param = this.formInline
				getBondHoldAnalysisListExport(param)
			},
        checkboxChange(val) {
            console.log(val);
            this.tagIds = val.join(",");
        },
        handlewarehousechange(val) {
            console.log(val);
            if (val) {
                this.WarehouseList.forEach(item => {
                    if (item.id == val) {
                        this.warehouseName = item.warehouseName;
                    }
                });
            }
            else {
                this.warehouseName = "";
            }
            console.log(this.warehouseName);
        },
        changgeTime2(time) {
            console.log(time);
            if (time.length) {
                this.formInline.registerStart = time[0];
                if (time.length > 1) {
                    this.formInline.registerEnd = time[1];
                }
            }
            else {
                this.formInline.registerStart = "";
                this.formInline.registerEnd = "";
            }
        },
        handleClickName(row) {
            console.log(row);
            // JSON.stringify(row)
            this.$router.push({
                path: "/user/userDetail",
                query: {
                    uid: row.uid
                }
            });
            // this.getsingleUserInfo(row)
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log("handleSelectionChange", val);
            let arr = [];
            if (val.length == 1) {
                this.selectEditForm = val[0];
            }
            else {
                this.selectEditForm = {};
            }
            this.checkedLimit = [];
            this.alldata = false;
            let userNameList = [];
            this.multipleSelection.map(item => {
                arr.push(item.uid);
                userNameList.push(item.username);
            });
            this.uids = arr.join(",");
            this.usernames = userNameList.join(",");
        },
        // 获得用户数据
        getdata() {
            let param = this.formInline;
            getWeekReport(param).then(res => {
                this.saveParams(this.$route.path, param);
                if (res.code == "200") {
					this.cityholdBonds=res.data.cityholdBonds;
					this.cityBuyBacks =res.data.cityBuyBacks;

                    this.weekData = res.data;
                }
            });
        },
        getAllCity() {
            getAllCity().then(res => {
                if (res.code == "200") {
                    this.cityList = res.data;
                }
            });
            getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
        },
        handleedit(row) {
            this.checkboxGroup = [];
            console.log(row);
            this.dialogVisible = true;
            this.uids = row.uid;
            this.type = "tag";
        },
        handleedit1() {
            if (this.uids == "") {
                this.$message.error("请选择用户");
                return;
            }
            else {
                this.checkboxGroup = [];
                this.dialogVisible = true;
                this.type = "tag";
            }
        },
    },
    // 创建前状态(里面是操作)
    beforeCreate() { },
    // 创建完毕状态(里面是操作)
    created() {
        this.getParams(this.$route.path);
        this.getdata();
        this.getAllCity();
    },
    // 挂载前状态(里面是操作)
    beforeMount() { },
    // 挂载结束状态(里面是操作)
    mounted() { },
    // 更新前状态(里面是操作)
    beforeUpdate() { },
    // 更新完成状态(里面是操作)
    updated() { },
    // 销毁前状态(里面是操作)
    beforeDestroy() { },
    // 销毁完成状态(里面是操作)
    destroyed() { },
    components: {  }
};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
	.title{
		font-size:24px;
		color:red;
		text-align:center;
		margin:10px
	}
	.content{
		font-size:18px;
		text-align:center;
		margin:10px
	}
</style>